import update from 'immutability-helper';
import _ from 'lodash'
import moment from 'moment'
import {
  getSkuUnit,
  getCustomCost,
  getCustom,
  getSkuMoney,
  // delCustomOrder,
} from "utils/interface";

//  数据模型
// import Model from "../viewModel";
import { CQ } from "utils/commonQuest";
const initCustomOrderState = {
  skuList: [],
  orderList: [], //定制单的行程订单列表
  editOrderId: null, // 用以标识当前是否编辑
  customerFile: null, // 出行人信息
  customData:null,//定制详情数据
  money:{
    rate: 1,
    coin: '￥'
  }
}

const _checkExist = (skuList, sku_id) => {
  return  _.find(skuList, function(o) {
     return o.sku_id == sku_id; 
  })
}

export const customOrder = {
  name: "customOrder",
  state: initCustomOrderState,
  reducers: {
    // 更新state项
    setFieldValue(state, data: any) {
      const { field, value } = data
      let newData = {
        [field]: { $set: value } 
      };
      return update(state, newData)
    },
    addOrUpdateOrderList(state, data:any) {
      let newOrderList = [...state.orderList];
      let ifExists = _.find(newOrderList,(order:any)=>{
        return order.id == data.id;
      })
      if(ifExists){
        newOrderList = _.map(newOrderList,(n:any)=>{
          if(n.id == data.id){
            return {...n, ...data};
          }
          return n;
        })
      }
      else{
        newOrderList.push(data)
      }
      /**
       * 相同SKU且出发日期相同
       */
      return update(state, {
        orderList: { $set: newOrderList } 
      })
    },
    delOrder(state, data:any) {
      let newOrderList = [...state.orderList];
      if(data.id){
        _.remove(newOrderList, (n)=> {
          return n.id == data.id;
        });
      }
      return update(state, {
        orderList: { $set: newOrderList } 
      })
    },
    prepareFormDataAndChangeFormState(state, data:any) {
      return update(state, {
        editOrderId: { $set: data.id } 
      })
    },
    cancelEditForm(state){
      return update(state, {
        editOrderId: { $set: null } 
      })
    },
    addUploadFile(state, data:any){
      return update(state, {
        customerFile: { $set: data } 
      })
    },
    resetCustomOrder(state){
      return update(state, {
        orderList:  { $set: initCustomOrderState.orderList } , //定制单的行程订单列表
        editOrderId:  { $set: initCustomOrderState.editOrderId } , // 用以标识当前是否编辑
        customerFile:  { $set: initCustomOrderState.customerFile } , // 出行人信息
        customData: { $set: initCustomOrderState.customData } ,//定制详情数据
      })
    }
  },
  effects: {
    async getSkuList(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      
      const data = await CQ(getSkuUnit(param));
      await this.setFieldValue({
        field: 'skuList',
        value: data,
      })
    },
    async addOrUpdateOrder(payload: any, rootState: any) {
      // 获取成本
      const params = { ...payload };
      const costData = await CQ(getCustomCost({
        sku_id:params.sku_id,
        go_time:params.go_time.format("YYYY-MM-DD"),
        num:params.num ? params.num : 0,
        adult_num:params.adult_num ? params.adult_num : 0,
        children_num:params.children_num ? params.children_num : 0,
        baby_num:params.baby_num ? params.baby_num : 0,
        tao_account: params.tao_account,
      }))
      this.addOrUpdateOrderList({...params, ...costData, go_time:params.go_time.format("YYYY-MM-DD"),})
    },
    async delOrderAndUpdateOrderList(payload:any, rootState:any) {
      this.delOrder(payload);
    },
    async editOrderAndUpdateOrderList(payload:any, rootState:any) {
      //检查skuList中是否包含当前修改的订单信息
      
      let { customOrder } = rootState;
      let { skuList } = customOrder;
      let isExist = _checkExist(skuList, payload.sku_id);
      if(!isExist){
        const data = await CQ(getSkuUnit({
          search: payload.skuName
        }));
        await this.setFieldValue({
          field: 'skuList',
          value: data,
        })
      }
      //点击编辑按钮，将form表单改为编辑模式，并将order数据填充至表格
      return this.prepareFormDataAndChangeFormState({id:payload.id});
    },
    async toSaveMode(payload:any, rootState:any) {
      //根据groupId查询出以保存的行程信息，并保存
      const customData = await CQ(getCustom({
        number:payload.group_number,
      }))
      await this.setFieldValue({
        field: 'customData',
        value: customData,
      })
      //取出已保存的行程信息，更新到orderList
      let newOrderList:any = [];
      _.forEach(customData.item,(element:any) => {

        /** 对数据进行处理比如拼音切割，日期格式转换 */
        let contact_pinyinSurname = '';
        let contact_pinyinName = '';
        if(element.contact_py){
          let arr = element.contact_py.split('-')
          if(arr && arr.length){
            contact_pinyinSurname = arr[0];
            contact_pinyinName = arr[1];
          }
        }

        let go_time = element.go_time ? moment(element.go_time * 1000).format("YYYY-MM-DD") : element.go_time

        newOrderList.push({...element,
          contact_pinyinSurname,
          contact_pinyinName,
          go_time
        })

      })
      await this.setFieldValue({
        field: 'orderList',
        value: newOrderList,
      })
      //根据groupId查询出以保存的行程信息，并替换orderList。
      //查询制单人等信息
      //setFieldValue
    },
    async editRow(payload:any, rootState:any) {
      this.toSaveMode({group_number : payload.number});
    },
    async getMoney(payload:any, rootState:any) {
      const money = await CQ(getSkuMoney({
        sku_id:payload.sku_id,
      }))
      this.setFieldValue({
        field: 'money',
        value: money,
      })
    }
  }
};
